import { t } from '@lingui/core/macro';
import { SiteDTO } from '@luminovo/api-contracts';
import { Chip, Tooltip } from '@luminovo/design-system';
import type { JSX } from 'react';

export function InventorySiteChip({
    isApproved,
    isPreferred,
    isExcluded,
    site,
    displaySiteName,
}: {
    isApproved: boolean;
    isPreferred: boolean;
    isExcluded: boolean;
    site: Pick<SiteDTO, 'name'>;
    displaySiteName: boolean;
}): JSX.Element {
    const message = () => {
        if (isPreferred) {
            return t`Preferred inventory site`;
        }
        if (isApproved) {
            return t`Approved inventory site`;
        }
        if (isExcluded) {
            return t`Excluded inventory site`;
        }
        return t`Inventory site not approved`;
    };
    const color = () => {
        if (isPreferred) {
            return 'blue';
        }
        if (isApproved) {
            return 'blue';
        }
        if (isExcluded) {
            return 'red';
        }
        return 'red';
    };

    return (
        <Tooltip
            title={
                <>
                    {site.name}
                    <br />
                    {message()}
                </>
            }
        >
            <span>
                <Chip color={color()} label={displaySiteName ? site.name : t`Inventory`} style={{ maxWidth: 150 }} />
            </span>
        </Tooltip>
    );
}
